module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 148
// module chunks = 0